import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';

import { AuthStoreService } from '@app/core/services/auth-store.service';

export const authenticatedOnlyGuard: CanActivateFn = (route, state) => {
  const authStore = inject(AuthStoreService);
  const router = inject(Router);

  if (!authStore.isAuthenticated()) {
    if (
      state.url.startsWith('/register/pms') &&
      route.queryParamMap.get('registrationInvalidated') === '1'
    ) {
      return router.createUrlTree(['/register'], {
        queryParams: { pmsConnectionFailed: '1' }
      });
    }
    return router.createUrlTree(['/login'], {
      queryParams: { returnUrl: state.url }
    });
  }

  if (authStore.mustChangePassword() && state.url !== '/change-password') {
    return router.createUrlTree(['/change-password']);
  }

  return true;
};
